var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"application-policy-container"},[_c('div',{staticClass:"company-application"},[_c('h1',{staticClass:"b-1-cl title a-5-bg"},[_vm._v(_vm._s(_vm.$t("application.policy.title")))]),_c('div',[_c('p',{staticClass:"b-1-cl desc a-5-bg",domProps:{"innerHTML":_vm._s(_vm.$t('application.policy.desc'))}})])])])
}
var staticRenderFns = []

export { render, staticRenderFns }